export const redirectUri = 'http://127.0.0.1:61759';

/** Больше setTimeout не ждёт (~24,8 суток): дальние сроки отсчитываем в несколько заходов */
export const MAX_TIMEOUT_MS = 2 ** 31 - 1;
